import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const PERCENT = 100

interface BreakdownBarProps {
  data: Record<string, number>
  colors: Record<string, string>
  labels?: Record<string, string>
}

export function BreakdownBar({ data, colors, labels = {} }: BreakdownBarProps): ReactElement {
  const { t } = useTranslation('admin')
  const total = Object.values(data).reduce((sum, value) => sum + value, 0)
  if (total === 0) {
    return (
      <div className="text-sm" style={{ color: 'var(--text-muted)' }}>
        {t('summary.noData')}
      </div>
    )
  }
  const entries = Object.entries(data).filter(([, value]) => value > 0)

  return (
    <div className="space-y-2">
      <div
        className="flex h-3 overflow-hidden rounded-full"
        style={{ background: 'var(--highlight)' }}
      >
        {entries.map(([key, value]) => (
          <div
            key={key}
            className={colors[key] ?? 'bg-slate-400'}
            style={{ width: `${((value / total) * PERCENT).toString()}%` }}
          />
        ))}
      </div>
      <div className="flex flex-wrap gap-4 text-xs">
        {entries.map(([key, value]) => (
          <div key={key} className="flex items-center gap-1.5">
            <div className={`h-2 w-2 rounded-full ${colors[key] ?? 'bg-slate-400'}`} />
            <span style={{ color: 'var(--text-dim)' }}>
              {labels[key] ?? key}: {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
